import React from 'react';
import { PRIMARY } from '../../../../theme';
export var Lock = function Lock(props) {
  var height = props.height,
      width = props.width;
  width = width ? width : '12';
  height = height ? height : '14';
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "1.23453",
    y: "5.39432",
    width: "9.53113",
    height: "7.43498",
    rx: "1.92045",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4751 5.11828L3.4751 3.28957C3.65042 2.21756 3.88807 1.69802 4.87764 1.20863C5.57891 0.861813 6.67119 0.792522 7.50733 1.46086C8.45403 2.21757 8.45403 3.0058 8.45403 3.51027V5.11828",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "0.497895",
    y1: "-0.497895",
    x2: "3.01189",
    y2: "-0.497895",
    transform: "matrix(-9.4701e-06 1 -1 -4.6435e-06 5.33789 7.37964)",
    stroke: props.color || PRIMARY,
    strokeWidth: "0.995789",
    strokeLinecap: "round",
    fill: "none"
  }));
};